// @flow
import React, {useEffect} from 'react';
import type {Node} from 'react';
import {Navigate} from 'react-router-dom';
import {Events, BridgeEventSources} from '@wellstone-solutions/common';
import {NAVIGATION_NAMES} from 'constants/Navigation';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';
import {useStores} from 'hooks/useStores';
import {useEventSource} from 'hooks/useEventSource';
import {StoryList} from './StoryList';

export const StoriesRoot = (): Node => {
  const {appUIStore, eventStore} = useStores();
  const hasStoryManager = useFeatureFlag(LD_FLAGS.STORY_MANAGER);

  useEventSource(BridgeEventSources.STORIES_PAGES);

  useEffect(() => {
    eventStore.addEvent(Events.VIEWED_STORY_LIST);
    appUIStore.setBreadcrumbs([
      {
        name: NAVIGATION_NAMES.stories,
        url: '/stories',
        active: true,
      },
    ]);
  }, [eventStore, appUIStore]);

  if (!hasStoryManager) {
    return <Navigate to="/" />;
  }

  return <StoryList />;
};
